/* Affichely Creators : mouvements ponctuels, film seulement lorsqu'il est visible.
   Sans JS, le contenu, les conditions et les commandes natives restent utilisables. */
(function () {
  function init(root) {
    if (!root || root.dataset.creatorsReady) return;
    root.dataset.creatorsReady = 'true';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var animations = [];
    function animate(element, frames, options) {
      if (!element || !element.animate || reduced.matches) return;
      var animation = element.animate(frames, options);
      animations.push(animation);
      animation.onfinish = animation.oncancel = function () {
        animations = animations.filter(function (item) { return item !== animation; });
      };
    }
    function enter(element, delay) {
      animate(element, [
        { opacity: 0, transform: 'translateY(26px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 850, delay: delay || 0, fill: 'backwards', easing: 'cubic-bezier(.2,.65,.3,1)' });
    }
    var reveal = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        reveal.unobserve(entry.target);
        if (reduced.matches || !entry.target.animate) return;
        if (entry.target.hasAttribute('data-artistes-stagger')) {
          Array.from(entry.target.children).forEach(function (child, index) { enter(child, index * 180); });
        } else enter(entry.target);
        var arc = entry.target.querySelector('[data-artistes-arc]');
        animate(arc, [
          { strokeDasharray: '0 100' }, { strokeDasharray: '15 100' }
        ], { duration: 1600, easing: 'ease-out' });
        animate(entry.target.querySelector('[data-artistes-stat]'), [
          { opacity: 0, transform: 'translateY(24px) scale(.94)' },
          { opacity: 1, transform: 'translateY(0) scale(1)' }
        ], { duration: 1250, easing: 'cubic-bezier(.16,1,.3,1)' });
        animate(entry.target.querySelector('.artistes-hero-image>img'), [
          { transform: 'scale(1.08)' }, { transform: 'scale(1)' }
        ], { duration: 2200, easing: 'cubic-bezier(.2,.65,.3,1)' });
      });
    }, { threshold: 0.12 }) : null;
    if (reveal) root.querySelectorAll('[data-artistes-reveal]').forEach(function (el) { reveal.observe(el); });

    // Chaque étape est observée séparément pour ne pas jouer les étapes hors écran sur mobile.
    var steps = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      var visible = entries.filter(function (entry) { return entry.isIntersecting; });
      visible.sort(function (a, b) {
        return a.target.compareDocumentPosition(b.target) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
      });
      visible.forEach(function (entry, index) {
        steps.unobserve(entry.target);
        var delay = index * 420;
        enter(entry.target, delay);
        animate(entry.target.querySelector('.artistes-step-number'), [
          { backgroundColor: '#c39872', color: '#fff', transform: 'scale(.85)' },
          { backgroundColor: '#294b43', color: '#fff', transform: 'scale(1)' }
        ], { duration: 1100, delay: delay, fill: 'backwards', easing: 'cubic-bezier(.16,1,.3,1)' });
        var vertical = window.matchMedia('(max-width: 760px)').matches;
        animate(entry.target.querySelector('.artistes-step-line'), [
          { transform: vertical ? 'scaleY(0)' : 'scaleX(0)' },
          { transform: vertical ? 'scaleY(1)' : 'scaleX(1)' }
        ], { duration: 1100, delay: delay + 200, fill: 'backwards', easing: 'cubic-bezier(.22,1,.36,1)' });
      });
    }, { threshold: 0.35 }) : null;
    if (steps) root.querySelectorAll('[data-artistes-step]').forEach(function (el) { steps.observe(el); });

    var video = root.querySelector('video');
    var button = root.querySelector('[data-artistes-video-toggle]');
    var inView = false;
    var manuallyPaused = false;
    var manuallyPlayed = false;
    var filmObserver;
    function playFilm() {
      var promise = video.play();
      if (promise) promise.catch(function () { updateButton(); });
    }
    function updateButton() {
      if (!button) return;
      button.setAttribute('aria-label', video.paused ? button.dataset.play : button.dataset.pause);
      button.dataset.paused = String(video.paused);
    }
    function syncFilm() {
      if (!video) return;
      if (inView && !document.hidden && !manuallyPaused && (!reduced.matches || manuallyPlayed)) playFilm();
      else video.pause();
    }
    function motionChanged() {
      if (reduced.matches) {
        animations.slice().forEach(function (animation) { animation.cancel(); });
        manuallyPlayed = false;
      }
      syncFilm();
    }
    if (video && button && 'IntersectionObserver' in window) {
      video.controls = false;
      button.hidden = false;
      video.addEventListener('play', updateButton);
      video.addEventListener('pause', updateButton);
      button.addEventListener('click', function () {
        if (video.paused) {
          manuallyPaused = false;
          manuallyPlayed = true;
          playFilm();
        } else {
          manuallyPaused = true;
          video.pause();
        }
      });
      filmObserver = new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        syncFilm();
      }, { threshold: 0.2 });
      filmObserver.observe(video);
      document.addEventListener('visibilitychange', syncFilm);
      updateButton();
    }
    reduced.addEventListener('change', motionChanged);
    function unload(event) {
      if (!event.target.contains(root)) return;
      if (reveal) reveal.disconnect();
      if (steps) steps.disconnect();
      animations.slice().forEach(function (animation) { animation.cancel(); });
      if (filmObserver) filmObserver.disconnect();
      if (video) video.pause();
      reduced.removeEventListener('change', motionChanged);
      document.removeEventListener('visibilitychange', syncFilm);
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);
  }
  document.querySelectorAll('[data-artistes-creators]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-artistes-creators]').forEach(init);
  });
})();
